import type {Recipe} from './types';

export const pastaRaguBianco: Recipe = {
    id: 21,
    key: "pastaRaguBianco",
    pictures: [
        {index: 0, url: "https://sundaypasta.com/wp-content/uploads/2016/03/Sunday-Pasta-Ragu-di-Salsiccia-in-Bianco-Garrubbo-Guide.jpg"},
    ],
    i18n: {
        IT: {
            title: "Pasta al ragù bianco",
            servings: "4 porzioni",
            ingredients: [
                "500 gr di pasta",
                "500 gr carne macinata di maiale o salsiccia",
                "misto di spezie per salsiccia",
                "1.5 cipolle",
                "rosmarino ",
                "olio di oliva",
                "1 bicchiere di latte",
                "1 bicchiere di vino bianco",
            ],
            steps: [
                "Se non hai la salsiccia dovrai prepararla da solo usando un misto di spezie leggero contenente sale pepe e aglio.\nMetti in un contenitore il macinato di maiale (più è grasso e meglio è) e unisci le spezie e un goccio di vino e rimescola \na mano o con un cucchiaio finché diventa omogeneo.",
                "Fai rosolare la cipolla con abbondante olio di oliva a fuoco medio per qualche minuto in una ampia padella.",
                "Dopo qualche minuto aggiungi sale e rosmarino e continua a cuocere fino a che la cipolla imbrunisce ma senza bruciarla.",
                "Aggiungi il macinato in padella e rompilo in tanti piccoli pezzi mentre cuoce.",
                "Quando la carne inizia a dorare, versa il vino in padella e lascia evaporare. ",
                "Aggiungi il latte, chiudi la padella con il coperchio e cuoci a fuoco basso fino a che il latte si addensa.",
                "Scola la pasta e tieni da parte un bicchiere di acqua di cottura.",
                "Versa la pasta nella padella e aggiungi acqua di cottura quanto basta affinché si formi una cremina.",
            ],
        },
        EN: {
            title: "White Ragù Pasta",
            servings: "4 servings",
            ingredients: [
                "500 gr pasta",
                "500 gr ground pork or sausage",
                "sausage spice mix",
                "1.5 onions",
                "rosemary ",
                "olive oil",
                "1 glass of milk",
                "1 glass of white wine",
            ],
            steps: [
                "If you don't have sausage, you will need to prepare it yourself using a light spice mix containing salt, pepper, and garlic.\nPlace the ground pork (the fattier, the better) in a container, add the spices and a splash of wine, and mix by hand or with a spoon until homogeneous.",
                "Sauté the onion with plenty of olive oil over medium heat for a few minutes in a large pan.",
                "After a few minutes, add salt and rosemary and continue cooking until the onion browns but does not burn.",
                "Add the ground meat to the pan and break it into small pieces as it cooks.",
                "When the meat starts to brown, pour the wine into the pan and let it evaporate.",
                "Add the milk, cover the pan with a lid, and cook on low heat until the milk thickens.",
                "Drain the pasta and reserve a glass of cooking water.",
                "Add the pasta to the pan and add cooking water as needed to create a creamy sauce.",
            ],
        },
        PL: {
            title: "Makaron z Białym Ragù",
            servings: "4 porcje",
            ingredients: [
                "500 g makaronu",
                "500 g mielonej wieprzowiny lub kiełbasy",
                "mieszanka przypraw do kiełbas",
                "1.5 cebuli",
                "rozmaryn ",
                "oliwa z oliwek",
                "1 szklanka mleka",
                "1 szklanka białego wina",
            ],
            steps: [
                "Jeśli nie masz kiełbasy, musisz przygotować ją sam, używając lekkiej mieszanki przypraw zawierającej sól, pieprz i czosnek.\nUmieść mieloną wieprzowinę (im tłustsza, tym lepsza) w misce, dodaj przyprawy i odrobinę wina, a następnie mieszaj ręcznie lub łyżką, aż masa będzie jednolita.",
                "Podsmaż cebulę na dużej ilości oliwy z oliwek na średnim ogniu przez kilka minut na dużej patelni.",
                "Po kilku minutach dodaj sól i rozmaryn, kontynuując smażenie, aż cebula się zrumieni, ale nie spali.",
                "Dodaj mielone mięso na patelnię, rozdrabniając je na małe kawałki podczas gotowania.",
                "Gdy mięso zacznie się rumienić, wlej wino na patelnię i odparuj.",
                "Dodaj mleko, przykryj patelnię pokrywką i gotuj na małym ogniu, aż mleko zgęstnieje.",
                "Odcedź makaron i zachowaj szklankę wody z gotowania.",
                "Wrzuć makaron na patelnię i dodaj wodę z gotowania, jeśli to konieczne, aby uzyskać kremowy sos.",
            ],
        },
    },
};
